import { render, staticRenderFns } from "./AddSubjectForm.vue?vue&type=template&id=417678be"
import script from "./AddSubjectForm.vue?vue&type=script&lang=js"
export * from "./AddSubjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports